<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Recepción de pedidos
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Facturación masiva</span>
      <span> /</span>
      <span>Recepción de pedidos</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form [formGroup]='formData' novalidate (ngSubmit)="buscar(1);">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fechaDesde" (dateChanged)="UpdateVendedorPorFecha()">
            </mdb-date-picker>
            <div *ngIf="
                                formData.get('fechaDesde').invalid &&
                                (formData.get('fechaDesde').dirty ||
                                formData.get('fechaDesde').touched)
                            ">
              <mdb-error *ngIf="formData.get('fechaDesde').hasError('required')">
                Ingrese fecha desde
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechahasta" [placeholder]="'Hasta'" required
              formControlName="fechaHasta" (dateChanged)="UpdateVendedorPorFecha()">
            </mdb-date-picker>
            <div *ngIf="
                                formData.get('fechaHasta').invalid &&
                                (formData.get('fechaHasta').dirty ||
                                formData.get('fechaHasta').touched)
                            ">
              <mdb-error *ngIf="formData.get('fechaHasta').hasError('required')">
                Ingrese fecha hasta
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsVendedores" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar vendedores" formControlName="vendedores">
            </mdb-select>
            <label>Vendedores</label>
            <div *ngIf="
                                formData.get('vendedores').invalid &&
                                (formData.get('vendedores').dirty ||
                                formData.get('vendedores').touched)
                            ">
              <mdb-error *ngIf="formData.get('vendedores').hasError('required')">
                Ingrese vendedores
              </mdb-error>
            </div>
          </div>
        </div>

        <div class="col d-flex align-items-center">
          <!-- Material checked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaResumen" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_RESUMEN" />
            <label class="form-check-label" for="rbVistaResumen">Vista Resumen</label>
          </div>
          <!-- Material unchecked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaDetalle" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_DETALLE" />
            <label class="form-check-label" for="rbVistaDetalle">Vista Detallada</label>
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div class="search-container md-form">
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="fileInput.click()">
          <mdb-icon fas icon="file-upload"></mdb-icon>
          Agregar Archivo
        </button>
        <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none;" />
        <input type="text" placeholder="Buscar..." class="search-input form-control" [value]="fileName" readonly />
      </div>
      <div class="card-footer text-muted filtros-footer justify-content-end" style="border-top: 1px solid #dee2e6">
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="limpiarBusqueda()">
          <mdb-icon fas icon="broom"></mdb-icon>
          Limpiar
        </button>
        <button mdbBtn type="submit" color="secondary" size="sm" mdbWavesEffect>
          <mdb-icon fas icon="search"></mdb-icon>
          Buscar
        </button>
      </div>
    </div>
  </div>
</form>
<!-- RESUMEN -->

<div class="card mb-2 wow detalle-cliente" *ngIf="resumenlistaDocumentos">
  <div class="card-body justify-content-between">
    <div class="table-responsive" *ngIf="formData.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">
              <mdb-checkbox [(ngModel)]="CheckBoxAllValue" (change)="checkAllChange($event)"
                [checked]="true"></mdb-checkbox>
            </th>
            <th scope="col">N° Ped.</th>

            <th scope="col">RUT</th>
            <th scope="col" style="max-width: 250px;">Cliente</th>
            <th scope="col" style="max-width: 250px;">Dirección</th>

            <th scope="col" class="text-right">Total</th>
            <th scope="col" class="text-right">IVA</th>
            <th scope="col" class="text-right">Total Bruto</th>
            <th scope="col" class="text-center">Estado Pedido</th>
            <th scope="col" class="text-center"></th>
            <th scope="col" class="text-center"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="resumen_loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!resumen_loading && resumenlistaDocumentos?.length === 0">
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let pedido of resumenlistaDocumentos" style="cursor: pointer;"
            [ngClass]="{'ContentRed': pedido.tieneproductosInactivos == true}">
            <td>
              <mdb-checkbox [checked]="pedido.additionalInfo.checked"
                (change)='checkDetalle(pedido.additionalInfo, $event)'></mdb-checkbox>
            </td>
            <td>{{pedido.codigo}}</td>
            <td>{{pedido.additionalInfo.rutFormato | rut}}</td>
            <td>{{pedido.clienteNombre}}</td>
            <td>{{pedido.direccion}}</td>

            <td class="text-right">{{pedido.monto_total | numerico}}</td>
            <td class="text-right">{{pedido.monto_total_iva | numerico}}</td>
            <td class="text-right">{{pedido.total_bruto | numerico}}</td>
            <td class="text-center">
              <mdb-badge pill="true" success="true" *ngIf="pedido.activo">Activo</mdb-badge>
              <mdb-badge pill="true" danger="true" *ngIf="!pedido.activo">Inactivo</mdb-badge>
            </td>
            <td>
              <button mdbBtn type="button" color="info" mdbWavesEffect class="btn-actions-sm" size="sm"
                (click)="loadPedido(pedido.codigo)" mdbTooltip="Ver" placement="right">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
            </td>
            <td>
              <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect size="sm"
                (click)="eliminarPedido(pedido)" mdbTooltip="Eliminar Pedido" placement="right">
                <mdb-icon fas icon="trash"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>

      </table>
      <app-pagination *ngIf="resumenlistaDocumentos?.length > 0" [context]="resumen_paginationContext"
        (onPageChange)="resumenOnPageChange($event)"></app-pagination>
    </div>

    <!-- DETALLE -->
    <div class="table-responsive" *ngIf="formData.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
      <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">
              <mdb-checkbox [(ngModel)]="CheckBoxAllValue" (change)="checkAllChange($event)"
                [checked]="true"></mdb-checkbox>
            </th>
            <th scope="col">N° Ped.</th>
            <th scope="col">Cliente / Producto</th>
            <th scope="col">Hora</th>
            <th scope="col">Fecha</th>
            <th scope="col">Dirección</th>
            <!-- <th scope="col">RUT</th> -->
            <!-- <th scope="col" style="max-width: 250px;">Cliente</th> -->
            <!-- <th scope="col" class="text-center">Bloq.</th>
                <th scope="col" class="text-center">Estado C.</th>
                <th scope="col">Dirección</th>
                <th scope="col">Comuna</th> -->
            <!-- <th scope="col">IVA</th>
                <th scope="col">ILA</th> -->
            <!-- <th scope="col">Vendedor</th> -->
            <th scope="col" class="text-right">Cantidad</th>
            <th scope="col" class="text-right">Precio Unitario</th>
            <th scope="col" class="text-right">Dsc. Lin</th>
            <th scope="col" class="text-right">Dsc. Global</th>
            <th scope="col" class="text-right">Total</th>
            <th scope="col" class="text-right">IVA</th>
            <th scope="col" class="text-right">Sub Total</th>
            <th scope="col" class="text-right">Total Bruto</th>
            <th scope="col" class="text-center">Estado Producto</th>
            <th scope="col" class="text-center"></th>
            <th scope="col" class="text-center"></th>

          </tr>
        </thead>
        <tbody *ngIf="listaDocumentos?.length === 0">
          <tr>
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
        </tbody>
        <tbody class="" *ngFor="let listaDocuments of listaDocumentos">
          <ng-container>
            <tr class="grey lighten-3">
              <td>
                <mdb-checkbox [checked]="listaDocuments.additionalInfo.checked"
                  (change)='checkDetalle(listaDocuments.additionalInfo, $event)'></mdb-checkbox>
              </td>
              <td style="font-weight: bold;"><b>{{listaDocuments.codigo}}</b></td>
              <td style="font-weight: bold;"><b>[{{listaDocuments.rutCliente | rut}}] -
                  {{listaDocuments.cliente_name}}</b></td>
              <td style="font-weight: bold;"><b>{{listaDocuments.fecha_registro | date:'shortTime'}}</b></td>
              <td style="font-weight: bold;"><b>{{listaDocuments.fecha_registro | fecha}}</b></td>
              <td style="font-weight: bold;"><b>{{listaDocuments.direccion}}</b></td>
              <td><b></b></td>
              <td><b></b></td>
              <td class="text-right" style="font-weight: bold;"><b>{{listaDocuments.total_descLineal | numerico}}</b>
              </td>
              <td class="text-right" style="font-weight: bold;"><b>{{listaDocuments.total_DescGbl | numerico}}</b></td>
              <td class="text-right" style="font-weight: bold;"><b>{{listaDocuments.total_neto | numerico}}</b></td>
              <td class="text-right" style="font-weight: bold;"><b>{{listaDocuments.total_iva | numerico}}</b></td>
              <td class="text-right" style="font-weight: bold;"><b>{{listaDocuments.SubTotal | numerico}}</b></td>
              <td class="text-right" style="font-weight: bold;"><b>{{listaDocuments.total_bruto | numerico}}</b></td>

              <td><b></b></td>
              <td><b></b></td>
              <td>
                <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                  (click)="eliminarPedido(listaDocuments)" mdbTooltip="Eliminar Pedido" placement="right">
                  <mdb-icon fas icon="trash"></mdb-icon>
                </button>
              </td>

            </tr>
            <tr *ngFor="let pedido of listaDocuments.groupItem"
              [ngClass]="{'ContentRed': pedido.producto_activo == false}">
              <td>
                <!-- <mdb-checkbox [checked]="pedido.additionalInfo.checked"
                            (change)='checkDetalle(pedido.additionalInfo, $event)'></mdb-checkbox> -->
              </td>
              <td>{{pedido.skuProducto}}</td>
              <td>{{pedido.descripcionProducto}}</td>
              <td></td>
              <td><b></b></td>
              <td><b></b></td>
              <!-- <td>{{pedido.fecha_registro | fecha}}</td> -->
              <!-- <td>{{pedido.additionalInfo.rutFormato | rut}}</td> -->
              <!-- <td>{{pedido.clienteNombre}}</td> -->
              <!-- <td class="text-center">
                        <mdb-icon fas icon="circle" class="text-danger" *ngIf="pedido.bloqueado"></mdb-icon>
                        <mdb-icon fas icon="circle" class="text-success" *ngIf="!pedido.bloqueado"></mdb-icon>
                    </td>
                    <td class="text-center">
                        <mdb-icon fas icon="circle" class="text-danger" *ngIf="!pedido.clienteActivo"></mdb-icon>
                        <mdb-icon fas icon="circle" class="text-success" *ngIf="pedido.clienteActivo"></mdb-icon>
                    </td>
                    <td>{{pedido.direccion}}</td>
                    <td>{{pedido.comuna}}</td> -->
              <!-- <td>$ 2.500</td>
                    <td>$ 2.500</td> -->
              <!-- <td>{{pedido.vendedor_nombre}}</td> -->
              <td class="text-right">{{pedido.cantidad}}</td>
              <td class="text-right">{{pedido.precio_unitario | numerico}}</td>
              <td class="text-right">{{pedido.monto_descuento | numerico}}</td>
              <td class="text-right"></td>
              <td class="text-right">{{pedido.monto_neto | numerico}}</td>
              <td class="text-right">{{pedido.monto_total_iva | numerico}}</td>
              <td class="text-right"></td>
              <td class="text-right">{{pedido.total_bruto | numerico}}</td>
              <td class="text-center">
                <mdb-badge pill="true" success="true" *ngIf="pedido.producto_activo">Activo</mdb-badge>
                <mdb-badge pill="true" danger="true" *ngIf="!pedido.producto_activo">Inactivo</mdb-badge>
              </td>
              <td></td>
              <td></td>


              <!-- <td>55598</td> -->
              <!-- <td>
                        <button mdbBtn type="button" color="info" mdbWavesEffect class="btn-actions-sm" size="sm"
                            (click)="loadPedido(pedido.codigo)" mdbTooltip="Ver" placement="right">
                            <mdb-icon fas icon="eye"></mdb-icon>
                        </button>
                    </td> -->
            </tr>
          </ng-container>
        </tbody>
        <app-pagination *ngIf="groupArr?.length > 0" [context]="detalle_paginationContext"
          (onPageChange)="onPageChangeDetalle($event)"></app-pagination>
      </table>
    </div>


  </div>
</div>
<div class="card mb-2 wow"
  *ngIf="formData.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN && resumenlistaDocumentos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <!-- <button mdbBtn type="button" color="info" mdbWavesEffect class="btn" (click)="print()">
          Imprimir
      </button> -->
    <button mdbBtn type="button" size="sm" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="downloadExcelPdfResumen('XLS')">
      Excel
    </button>

    <button mdbBtn type="button" size="sm" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="showModalConvertirANotasResumen()" [disabled]="!areSelected || !botonConvertir">
      Convertir a nota de venta
    </button>
  </div>
</div>

<div class="card mb-2 wow" *ngIf="formData.get('tipoVista').value === RB_TIPO_VISTA_DETALLE && groupArr?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <!-- <button mdbBtn type="button" color="info" mdbWavesEffect class="btn" (click)="print()">
            Imprimir
        </button> -->

    <button mdbBtn type="button" size="sm" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="downloadExcelDetalle('XLS')">
      Excel
    </button>

    <button mdbBtn type="button" size="sm" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="showModalConvertirANotasDetalle()" [disabled]="!areSelected || !botonConvertir">
      Convertir a nota de venta
    </button>
  </div>
</div>



<!-- MODAL Convertir a notas de venta -->
<div mdbModal #convertirNotas="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Convertir a notas de venta
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="convertirNotas.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <h6 class="text-center" style="color:rgb(243, 113, 113)">
              {{mensajeMostrado}}
            </h6>

            <h6 class="text-center">
              ¿ Está seguro que desea convertir los pedidos seleccionados a
              notas de venta ?
            </h6>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="convertirNotas.hide()"
          mdbWavesEffect [disabled]="processing">
          Cerrar
        </button>
        <!-- <button type="button" class="btn btn-success waves-light" mdbWavesEffect
                    (click)="convertirANotasVenta()">
                    Si, convertir a notas de venta
                </button> -->
        <div *ngIf="formData.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
          <app-api-button [processing]="processing" (click2)="convertirANotasVentaResumen()">
            Si, convertir a notas de venta
          </app-api-button>
        </div>

        <div *ngIf="formData.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
          <app-api-button [processing]="processing" (click2)="convertirANotasVentaDetalle()">
            Si, convertir a notas de venta
          </app-api-button>
        </div>

      </div>
    </div>
  </div>
</div>

<app-recepcion-pedidos-modal-ver-pedido></app-recepcion-pedidos-modal-ver-pedido>
<app-recepcion-pedidos-modal-result></app-recepcion-pedidos-modal-result>
<app-modal-confirm title="{{ tittle }}" contentText="{{message}}"></app-modal-confirm>